import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_83g95mszzx: FaireCollectionEntity = {
  token: "pbc_83g95mszzx",
  type: "collection",
  name: "Nutcracker 🎁🎀 PREORDER",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3aa4e94462cd7fa9a8cfed114ec51aaf1f71a4a143d781e142e4ffa78e40b6f8.jpeg",
  itemCount: 1,
  description:
    "Get ready for twirls, tunes, and holiday fun with our new Nutcracker collection!\n\n**This collection is on preorder and will ship the week of 9/15**",
  brandToken: "b_gro99lye",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:26:36.772Z",
    importedBy: "entity-db-import-collections",
  },
};
